import React, { Component } from 'react'
import { Container } from 'react-bootstrap';
import axios from 'axios';
import { Order } from '../../components';
import { AdminNav } from '../../helpers';
import { Redirect } from 'react-router-dom'
import { DebitNote} from '../../helpers/functionForFinancial'
export default class ValidateFinancial extends Component {
  state = {
    FinancialSheet : {
    },
    paidWageSheet: {
      Extra : 0,
      redirect : false,
      total : 0,
    },
    Token : 'token',
    holiday : false,
  } 
  componentWillMount(){
    this.setState({
      FinancialSheet : this.props.location.state,
    },() => console.log(this.state))
  }
  componentDidMount(){
    // console.log(this.props.location.listInComplete)
    DebitNote(this.props.location.state,this.props.location.wageReport,this.props.location.getCompanyName)
  }
  handleExtra = (e) => {
    let newPaidWageSheet = this.state.paidWageSheet;
    newPaidWageSheet.Extra = parseInt(e.target.value);

    this.setState({
      paidWageSheet : newPaidWageSheet,
    },() => { console.log(this.state)})  
  }
  renderRedirect(){
    if(this.state.redirect){
      return <Redirect to="/FinancialAccount"/>
    } 
  }

  handleSubmit = () => {
    let { paidWageSheet,FinancialSheet } = this.state;
    let { jobID } = FinancialSheet;
    let { Extra } = paidWageSheet;
    this.setState({
      jobID,
      Extra,
    },() => {
      axios.post(
        'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
        {
          'action': 'paidWage',
          'data' : this.state,
        }
      ).then(res => {
        this.setState({
          ...this.state,
          redirect : true,
        })
      })
    })
  }
  handleChangRate = ()=>{
    this.setState({
      ...this.state,
      holiday : !this.state.holiday,
    },()=>{
      if(this.state.paidWageSheet['start'] && this.state.paidWageSheet['end']){
        let start = this.state.paidWageSheet['start'] 
        let end = this.state.paidWageSheet['end']
        if(start.length == 5 && end.length == 5){
          let holiday = this.state.holiday
          let startHrInMin = (parseInt(start.slice(0,2))*60)
          let startMinInMin = (parseInt(start.slice(start.length-2,start.length)))
          let startMin =  startHrInMin + startMinInMin
          let endMin = (parseInt(end.slice(0,2))*60) + (parseInt(end.slice(end.length-2,end.length)))
          let total = Math.ceil((endMin - startMin)/60) * 0
          if(holiday){
            if(parseInt(start.slice(0,2)) <= 7 ){
              total += 100
            }
            if(parseInt(start.slice(0,2)) <= 7 && parseInt(end.slice(0,2)) < 18){
              total += 100
            }
            if(parseInt(start.slice(0,2)) >= 8 && parseInt(end.slice(0,2)) < 18){
              total += 100
            }
            if(parseInt(start.slice(0,2)) >= 8 && parseInt(end.slice(0,2)) >= 18){
              total += 100
            }
            if(parseInt(end.slice(0,2)) >= 18 ){
              total += 100
            }
            if(parseInt(start.slice(0,2)) <= 7 && parseInt(end.slice(0,2)) >= 18){
              total += 100
            }
          }else{
            if(parseInt(start.slice(0,2)) <= 7 ){
              total += 100
            }
            if(parseInt(end.slice(0,2)) >= 18 ){
              total += 100
            }  
          }
          total += parseFloat(this.state.paidWageSheet.Extra).toFixed(2)
          Object.keys(this.state.FinancialSheet.description.description).map((title)=>{
            if(Number.isInteger(parseInt(title))){
              total += parseFloat(this.state.FinancialSheet.description.description[title]['quantity']).toFixed(2)
            }
          })
          this.setState({
            ...this.state,
            paidWageSheet :{
              ...this.state.paidWageSheet,
              total : total,
            }
          },()=>{console.log(this.state)})
        }
      }
    })
  }
  renderHoliday = ()=>{
    if(this.state.holiday){
      return 'วันหยุด'
    }else{
      return 'วันปกติ'
    }
  }
  handleTime = (e)=>{
    this.setState({
      ...this.state,
      paidWageSheet :{
        ...this.state.paidWageSheet,
        [e.target.id] : e.target.value,
      }
    },()=>{
      if(this.state.paidWageSheet['start'] && this.state.paidWageSheet['end']){
        let start = this.state.paidWageSheet['start'] 
        let end = this.state.paidWageSheet['end']
        if(start.length == 5 && end.length == 5){
          let holiday = this.state.holiday
          let startHrInMin = (parseInt(start.slice(0,2))*60)
          let startMinInMin = (parseInt(start.slice(start.length-2,start.length)))
          let startMin =  startHrInMin + startMinInMin
          let endMin = (parseInt(end.slice(0,2))*60) + (parseInt(end.slice(end.length-2,end.length)))
          let total = Math.ceil((endMin - startMin)/60) * 0
          if(holiday){
            if(parseInt(start.slice(0,2)) <= 7 ){
              total += 100
            }
            if(parseInt(start.slice(0,2)) <= 7 && parseInt(end.slice(0,2)) < 18){
              total += 100
            }
            if(parseInt(start.slice(0,2)) >= 8 && parseInt(end.slice(0,2)) < 18){
              total += 100
            }
            if(parseInt(start.slice(0,2)) >= 8 && parseInt(end.slice(0,2)) >= 18){
              total += 100
            }
            if(parseInt(end.slice(0,2)) >= 18 ){
              total += 100
            }
            if(parseInt(start.slice(0,2)) <= 7 && parseInt(end.slice(0,2)) >= 18){
              total += 100
            }
          }else{
            if(parseInt(start.slice(0,2)) <= 7 ){
              total += 100
            }
            if(parseInt(end.slice(0,2)) >= 18 ){
              total += 100
            }  
          }
          total += parseFloat(this.state.paidWageSheet.Extra)
          Object.keys(this.state.FinancialSheet.description.description).map((title)=>{
            if(Number.isInteger(parseInt(title))){
              total += (parseFloat(this.state.FinancialSheet.description.description[title]['quantity'])*2.5)
            }
          })
          console.log(total)
          total = total.toFixed(2)
          console.log(total)
          this.setState({
            ...this.state,
            paidWageSheet :{
              ...this.state.paidWageSheet,
              total : total,
            }
          },()=>{console.log(this.state)})
        }
      }
    })
  }
  render() {
    let { FinancialSheet,paidWageSheet } = this.state;
    return (
      <Container>
        {this.renderRedirect()}
        <AdminNav></AdminNav> 
        <Order getCompanyName={this.props.location.getCompanyName} FinancialSheet={FinancialSheet} handleTime={this.handleTime} paidWageSheet={paidWageSheet} handleExtra={this.handleExtra} handleSubmit={this.handleSubmit}/>
        <p>{this.renderHoliday()}</p>
        <button onClick={this.handleChangRate}> Change Rate </button>
      </Container>
    )
  } 
}
